import globals from "./globals";
import $ from "cash-dom";
import { ScrollTween2 as ScrollTween } from "Utilities";

const component = (function () {
    $(document).ready(function () {
        if ($(".scroll-indicator").length) {
            if (globals.debug) console.log("component-scroll-indicator initialized");
            $(".scroll-indicator").each(function (_e) {
                var indicator = $(this);
                var keyframes = indicator
                    .parents(".layout-panning-image, .layout-sticky-lottie, .layout-sticky-image")
                    .find(".keyframe");
                keyframes.each(function () {
                    new ScrollTween({
                        element: $(this)[0],
                        from: "top-middle",
                        to: "bottom-middle",
                        callback: function (_n, _el) {
                            var index = $(_el).attr("data-index");
                            $(indicator)
                                .find(`[data-index="${index}"] .scroll-progress`)
                                .css("transform", `scaleX(${_n})`);
                        },
                    });
                });
            });
        }
    });
})();

export default component;
